export const fieldMapperValidator =
  (mandatorySelectionFields = []) =>
  (values) => {
    const errors = {};

    if (!values.mapping) {
      errors.mapping = 'No fields to map';
    } else {
      const mappingFields = values.mapping || [];
      const mandatorySelectionFieldsLabels = mandatorySelectionFields.map(
        (f) => f.label
      );
      const mandatorySelectionFieldsKeys = mandatorySelectionFields.map(
        (f) => f.value
      );

      const mandatorySelectionFieldsValues = mappingFields
        .filter((fieldValue) => {
          return mandatorySelectionFieldsKeys.includes(
            fieldValue.to ? fieldValue.to.value : ''
          );
        })
        .map((fieldValue) => fieldValue.to.value);

      const missingFields = mandatorySelectionFields
        .filter(
          (mandatoryField) =>
            !mandatorySelectionFieldsValues.includes(mandatoryField.value)
        )
        .map((field) => field.label);

      if (missingFields.length > 0) {
        errors.mappingGeneralError = {
          message: 'Missing mandatory fields',
          mandatoryFields: mandatorySelectionFieldsLabels,
          missingFields,
        };
      }
    }

    return errors;
  };
